import snarkdown from 'snarkdown'
import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

const MIN_SCROLL_OFFSET = 100

class LandingAboutComponent extends Component {
  init() {
    window.addEventListener('micrio-data', event => this.initAfterData(event?.detail?.index?.about || {}))

    this.initScrollTween()
  }

  initAfterData({ title = '', text = '', text2 = '' }) {
    const template = this.element.querySelector('.landing-about__template')
    const wrapper = this.element.querySelector('.landing-about__wrapper')

    if (!template || !wrapper || (!title && !text && !text2)) {
      return
    }

    const clone = template.content.cloneNode(true)

    const elementTitle = clone.querySelector('.landing-about__title')
    const elementText = clone.querySelector('.landing-about__text')
    const elementText2 = clone.querySelector('.landing-about__text + .landing-about__text')

    // The text1 field is used for multiple paragraphs. If a list of items with enter is required, use text2.
    text2 = text2 ? text2.replace(/\n&nbsp;\n/g, '\n') : text2
    console.log(text2)

    title ? (elementTitle.textContent = title) : elementTitle.remove()
    text ? (elementText.innerHTML = snarkdown(text)) : elementText.remove()
    text2 ? (elementText2.innerHTML = snarkdown(text2)) : elementText2.remove()

    wrapper.appendChild(clone)

    wrapper.classList.add('landing-about__wrapper--visible')
  }

  initScrollTween() {
    const wrapper = this.element.querySelector('.landing-about__wrapper')

    window.GSAP.set(wrapper, { force3D: true })

    /*
    window.ScrollTrigger.create({
      trigger: wrapper,
      start: 'top top',
      end: 'bottom top',
      onUpdate: self => {
        wrapper.style.filter = `blur(${-20 - +(20 / 100) * (self.progress * 100)}px`
        wrapper.style.setProperty('--color-foreground', `var(--color-${self.progress === 0 ? 'orange-light' : 'black'})`)
        wrapper.style.pointerEvents = self.progress === 0 ? 'unset' : 'none'

        if (self.direction === -1 && self.progress === 0) {
          document.querySelector('.container--wrapper')?.style.setProperty('--color-foreground', `var(--color-orange-light)`)
        }
      },
    })
    */
    window.ScrollTrigger.create({
      trigger: wrapper,
      start: 'top bottom',
      end: 'bottom bottom+=50%',
      onUpdate: self => {
        const progress = window.pageYOffset < MIN_SCROLL_OFFSET ? 0 : window.pageYOffset > document.scrollingElement.offsetHeight - MIN_SCROLL_OFFSET ? 1 : self.progress

        //wrapper.style.filter = `blur(${20 + -((20 / 100) * (progress * 100))}px`
        wrapper.style.setProperty('--color-foreground', `var(--color-${progress === 1 ? 'orange-light' : 'black'})`)
        wrapper.style.pointerEvents = progress === 1 ? 'unset' : 'none'

        if (self.direction === 1 && progress === 1) {
          document.querySelector('.container--wrapper')?.style.setProperty('--color-foreground', `var(--color-orange-light)`)
        }
      },
    })
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'landing-about', LandingAboutComponent))
